import React from 'react'

import EntityDetailItem from 'syft-acp-core/components/EntityDetail/EntityDetailItem'

const ListingNoShifts = () => <EntityDetailItem padded>No shifts</EntityDetailItem>

export default ListingNoShifts
